// livraisonsMobileShared.js — helpers de l'écran « Livraisons » mobile.
//
// Le desktop (GestionLivraisons.tsx) n'expose ni édition ni suppression d'un bordereau :
// on consulte, on émet, on réimprime. Les permissions reflètent exactement cela.

const ROOT = "Gestion Commerciale.Ventes.Livraisons";
export const PERM = {
  view: `${ROOT}.view`,
  create: `${ROOT}.create`,
  generatePdf: `${ROOT}.generate_pdf`,
};

export const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("fr-FR");
};

/** Le bordereau porte une heure (le desktop utilise un DatePicker showTime). */
export const fmtDateTime = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "-"
    : d.toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

/** Valeur d'un <input type="datetime-local"> : YYYY-MM-DDTHH:mm en heure locale. */
export const toLocalDateTimeValue = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

/** Statut de paiement de la vente → ton de `Pill` (GestionLivraisons.tsx:529-534). */
export const paymentPill = (status) => {
  const s = String(status || "");
  if (s === "Payé") return { tone: "ok", label: "Payé" };
  if (s === "Partiellement payé") return { tone: "warn", label: "Partiel" };
  if (s === "Non payé") return { tone: "danger", label: "Non payé" };
  return { tone: "off", label: s || "—" };
};

/**
 * L'historique est filtré `status="delivered"` côté serveur : le desktop code donc
 * le tag en dur (l.604 et l.199). On reproduit ce choix plutôt que de lire `status`.
 */
export const deliveredPill = () => ({ tone: "ok", label: "Livrée" });

export const clientNameOf = (row) =>
  row.client_name || row.client_name_snapshot || "Client de passage";

export const pdfNameOf = (delivery) => `Bordereau_${delivery.delivery_number}.pdf`;
